import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { ThemeToggle } from '@/components/ThemeToggle'
import { useColorModeValue } from '@/components/ui/color-mode'
import { uit } from '@/theme'
import { Flex, HStack } from '@chakra-ui/react'
// import { BackgroundTasksMenu } from './BackgroundTasksMenu'
import { NotificationsMenu } from './NotificationsMenu'
import { UserMenu } from './UserMenu'

/**
 * Header Component
 * Modern top navigation bar with notifications, theme toggle, and user menu
 * Uses centralized UI constants from theme/foundations.js
 */
export function Header({ sidebarWidth }) {
  const bgColor = useColorModeValue('white', 'gray.900')
  const borderColor = useColorModeValue('#DFE1E6', 'gray.700')

  return (
    <Flex
      as="header"
      pos="fixed"
      top={ 0 }
      right={ 0 }
      left={ sidebarWidth }
      h={uit.layout.header.height}
      bg={ bgColor }
      borderBottom="1px"
      borderColor={ borderColor }
      align="center"
      justify="space-between"
      px={ 8 }
      zIndex="sticky"
      transition={`left ${uit.animations.transition.slow} ${uit.animations.timing.smooth}`}
      boxShadow="0 1px 1px 0 rgba(9, 30, 66, 0.08)"
    >
      {/* Left side - Language and Theme controls */}
      <HStack spacing={ 3 }>
        <LanguageSwitcher />
        <ThemeToggle />
      </HStack>

      {/* Right side - Notifications and User menu */}
      <HStack spacing={ 3 }>
        <NotificationsMenu />
        {/* <BackgroundTasksMenu /> */}
        <UserMenu />
      </HStack>
    </Flex>
  )
}

export default Header
